module.exports = __webpack_public_path__ + "static/media/35.35121a8b.mp3";